export const API_ORIGIN = import.meta.env.VITE_API_ORIGIN;
export const ADMIN_ORIGIN = import.meta.env.VITE_ADMIN_ORIGIN;
export const APP_ENV = import.meta.env.MODE;
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const VERSION = import.meta.env.VITE_APP_TAG as string;

export * from './arrow';
